import { ACTION, VIEWER_SIDEBAR_TAB } from 'Pods/ThreeDStudio/Store/constants'

// The variations tab has no settings slice of its own; the active enhancement is
// tracked by schema.enhancedAction. Map it to the settings slice the matching
// enhancement tab would use (inverse of the tab -> action map in actions/ui.js).
const VARIATIONS_SETTINGS_KEY_BY_ACTION = {
  [ACTION.MESH_SIMPLIFICATION]: 'remeshSettings',
  [ACTION.RETEXTURE]: 'textureSettings',
  [ACTION.MESH_SEGMENTATION]: 'segmentSettings',
}

/**
 * Resolves the store settings slice key for the active enhancement.
 *
 * Most tabs map directly to `${activeViewerSidebarTab}Settings`. The variations
 * tab is the exception: it reuses another enhancement's slice, inferred from
 * `enhancedAction`. Returns null when no tab is active or the action has no slice.
 *
 * @param {string|undefined} activeViewerSidebarTab - From ui.activeViewerSidebarTab
 * @param {string|undefined} enhancedAction - From schema.enhancedAction
 * @returns {string|null}
 */
export const getEnhancedSettingsKey = (activeViewerSidebarTab, enhancedAction) => {
  if (!activeViewerSidebarTab) {
    return null
  }

  if (activeViewerSidebarTab === VIEWER_SIDEBAR_TAB.VARIATIONS) {
    return VARIATIONS_SETTINGS_KEY_BY_ACTION[enhancedAction] || null
  }

  return `${activeViewerSidebarTab}Settings`
}
